<template>
  <div class="app-container">
    <PageTitle title="导游列表" ref="pageTitle" v-model="listQuery.city" @onChange="changeCity" />
    <div class="filter-container">
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入导游姓名"
        v-model="listQuery.name"
        @change="handleName"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入身份证"
        v-model="listQuery.card_no"
        @change="handleCardNo"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入手机号"
        v-model="listQuery.mobile"
        @change="handleMobile"
      ></el-input>
      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="$refs.edit.handleCreate()"
        >添加导游</el-button
      >
    </div>
    <Table :data="list" :columns="columns" :loading="listLoading">
      <template v-slot:cert_img>
        <el-table-column label="导游图片" width="100" align="center">
          <template slot-scope="scope">
            <el-link
              :href="scope.row.cert_img"
              target="_blank"
              style="text-decoration: underline"
              :underline="false"
              >查看照片</el-link
            >
          </template>
        </el-table-column>
      </template>
      <template v-slot:city>
        <el-table-column label="城市" width="100" align="center">
          <template slot-scope="scope">
            {{
              ['', '苏州', '南京', '徐州', '杭州', '济南', '曲阜', '沈阳', '潍坊', '上海'][
                scope.row.city
              ]
            }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:status>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            {{ ['未审核', '在线', '离线'][scope.row.status] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:add_time>
        <el-table-column label="添加时间" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="success" :underline="false">{{ scope.row.add_time }}</el-link>
          </template>
        </el-table-column>
      </template>
      <template v-slot:action>
        <el-table-column label="操作" minWidth="220">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleReview(scope.row.id)"
              v-if="scope.row.status == 0"
              >审核通过</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="$refs.edit.handleEdit(scope.row.id)"
            />
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              @click="handleDel(scope.row.id)"
            />
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
    <Edit ref="edit" />
  </div>
</template>

<script>
import { getList, del, review } from '@/api/guides'
import PageTitle from '@/components/PageTitle'
import Edit from './components/Edit'
import ProjectMixin from './ProjectMixin'
export default {
  name: 'GuidesIndex',
  components: {
    PageTitle,
    Edit
  },
  mixins: [ProjectMixin],
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        city: '',
        name: '',
        card_no: '',
        mobile: ''
      },

      columns: [
        {
          type: 'index',
          align: 'center',
          label: '序号',
          width: '50'
        },
        {
          label: '导游ID',
          width: '120',
          align: 'center',
          prop: 'id'
        },
        {
          label: '导游姓名',
          width: '100',
          prop: 'name',
          align: 'center'
        },
        {
          label: '导游手机号',
          width: '120',
          prop: 'mobile',
          align: 'center'
        },
        {
          label: '导游身份证',
          width: '160',
          prop: 'card_no',
          align: 'center'
        },
        {
          label: '导游证',
          slot: 'cert_img'
        },
        { label: '城市', slot: 'city' },
        { label: '服务项目', width: '180', prop: 'project_names' },
        { label: '状态', slot: 'status' },
        {
          label: '添加时间',
          slot: 'add_time'
        },
        {
          label: '操作',
          slot: 'action'
        }
      ]
    }
  },
  created() {
    this.fetchData()
    // this.ProjectM
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleName(value) {
      this.listQuery.name = value
      this.handleFilter()
    },
    handleCardNo(value) {
      this.listQuery.card_no = value
      this.handleFilter()
    },
    handleMobile(value) {
      this.listQuery.mobile = value
      this.handleFilter()
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: 1,
        name: '',
        card_no: '',
        mobile: ''
      }
      this.fetchData()
    },
    // 获取数据
    fetchData() {
      this.listLoading = true
      getList(this.listQuery).then((res) => {
        const _this = this
        this.list = res.data.results.map((item) => {
          return { ...item, project_names: _this.getProjectNames(item.projects) }
        })

        this.count = res.data.count
        this.listLoading = false
      })
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
      this.fetchData()
    },
    /**
     * @description: 审核通过
     * @param {*} uuid
     * @return {*}
     */
    handleReview(uuid) {
      this.$confirm('确认通过该导游申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          review(uuid).then(() => {
            this.$notify({
              title: '成功',
              message: '审核成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    },
    // 删除
    handleDel(uuid) {
      this.$confirm('确认删除该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          del(uuid).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
